var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"start": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"vendors-node_modules_react-toastify_dist_ReactToastify_css":1,"src_js_common_base_scss-src_js_common_colorThemes_scss-src_js_components_Icon_index_scss-src_-2e92ab":1,"src_js_components_Button_index_jsx-src_js_components_Layout_index_jsx-src_js_components_Logo_-503366":1,"src_js_components_Checkbox_index_scss-src_js_components_Label_index_scss-src_js_components_To-558952":1,"src_js_components_Form_index_jsx-src_js_utils_validateMap_jsx":1,"src_js_router_Entrance_index_jsx-node_modules_rc-slider_assets_index_css-node_modules_rc-tool-b764d1":1,"vendors-node_modules_paypal_react-paypal-js_dist_esm_react-paypal-js_js-node_modules_js-cooki-437f98":1,"vendors-node_modules_lodash_once_js-node_modules_lodash_sortBy_js-node_modules_recharts_es6_c-104bee":1,"src_js_components_ModalManager_index_jsx-src_js_components_Charts_BarSparkLine_Filler_index_s-97fdaa":1,"src_js_components_DpElems_ButtonEmployees_index_jsx-src_js_components_Header_index_jsx-src_js-091c88":1,"src_js_router_App_index_jsx":1,"src_js_components_OnboardingSidebar_index_jsx":1,"src_js_router_Setup_index_jsx":1,"src_js_router_SetupEmailWithIntegration_index_jsx-node_modules_rc-slider_assets_index_css-nod-34b475":1,"node_modules_lodash_assign_js-src_js_router_ConfirmEmail_index_jsx-node_modules_twemoji_dist_-07f365":1,"src_js_router_Invitation_index_jsx":1,"src_js_router_Onboarding_index_jsx":1,"node_modules_lodash_groupBy_js-node_modules_react-toastify_dist_ReactToastify_css-src_js_rout-7832f8":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr